/* eslint-disable camelcase */
import { useState } from 'react'
import * as FiIcons from 'react-icons/fi'
import { formatCurrency, convertCurrency } from '../Library/Tools/CurrencyConverter'
import {
  ItemRow,
  ItemInfo,
  ItemMain,
  ItemTitle,
  ItemDescription,
  ItemPrice,
  ItemActions,
  QuantityGroup,
  QuantityLabel,
  QuantityInput,
  ButtonGroup,
  InfoButton,
  AddButton
} from './ArticoliDrawer.styles'

export default function ArticoloRow ({ item, tipo, isAdded, onAdd, onInfo, valuta }) {
  const [qta, setQta] = useState(1)

  const handleAdd = () => {
    const qtaNum = parseInt(qta) || 0
    if (qtaNum > 0) {
      onAdd(item, qtaNum)
    }
  }

  const handleKeyPress = (e) => {
    const qtaNum = parseInt(qta) || 0
    if (e.key === 'Enter' && qtaNum > 0) {
      handleAdd()
    }
  }

  const handleQtaChange = (e) => {
    const value = e.target.value
    // Permetti stringa vuota temporaneamente
    if (value === '') {
      setQta('')
    } else {
      const num = parseInt(value)
      if (!isNaN(num) && num >= 0) {
        setQta(num)
      }
    }
  }

  /**
   * Calcola il prezzo da mostrare in base al tipo di item
   *
   * IMPORTANTE: Questa formula deve SEMPRE corrispondere a PricingEngine.calculateBaseCost()
   * nel backend (ems-be/src/services/PricingEngine.js)
   *
   * Formula per articoli:
   * 1. costoBase = prezzoAcquisto + (trasporto / capacita_trasporto)
   * 2. costoAlPezzo = costoBase * (1 + dazi/100)
   *
   * @returns {number} Prezzo calcolato nella valuta dell'articolo/servizio
   */
  const getPrezzo = () => {
    if (tipo === 'articoli') {
      // Per articoli: calcola il prezzo al pezzo dinamicamente
      // NOTA: Questa formula deve corrispondere a backend/PricingEngine.calculateBaseCost()
      const { prezzoAcquisto = 0, trasporto = 0, capacita_trasporto = 1, dazi = 0 } = item

      if (capacita_trasporto === 0) {
        return 0
      }

      // Step 1: Calcola costo base (prezzo acquisto + trasporto distribuito)
      const costoBase = prezzoAcquisto + (trasporto / capacita_trasporto)

      // Step 2: Applica dazi (customs duty)
      const costoAlPezzo = costoBase * (1 + dazi / 100)

      return costoAlPezzo
    } else {
      // Per servizi: usa il costo direttamente (no formula complessa)
      return item.costo || 0
    }
  }

  // Ottieni prezzo nella valuta dell'item
  const prezzoCalcolato = getPrezzo()

  // Ottieni la valuta dell'item (articolo o servizio)
  const valutaItem = item.valuta || 'EUR'
  const valutaAzienda = valuta || 'EUR'

  // Se la valuta dell'item è diversa da quella dell'azienda, converti
  const isDifferentCurrency = valutaItem !== valutaAzienda
  const prezzo = isDifferentCurrency
    ? convertCurrency(prezzoCalcolato, valutaItem, valutaAzienda)
    : prezzoCalcolato

  const qtaNum = parseInt(qta) || 0
  const subtotale = prezzo * qtaNum

  // Info secondarie da mostrare
  const getSecondaryInfo = () => {
    if (tipo === 'articoli') {
      const parts = []
      if (item.referenza) parts.push(`Ref: ${item.referenza}`)
      if (item.fornitore?.fornitore) parts.push(item.fornitore.fornitore)
      if (item.produttore?.produttore) parts.push(item.produttore.produttore)
      return parts.join(' • ')
    } else {
      return item.descrizione || ''
    }
  }

  return (
    <ItemRow isAdded={isAdded}>
      <ItemInfo>
        <ItemMain>
          <ItemTitle>{item.titolo || 'Senza titolo'}</ItemTitle>
          <ItemDescription>{getSecondaryInfo()}</ItemDescription>
        </ItemMain>
        <ItemPrice>
          {formatCurrency(prezzo, valutaAzienda)}
          {isDifferentCurrency && (
            <span style={{ fontSize: '0.85em', color: '#6b7280', marginLeft: '4px' }}>
              ({formatCurrency(prezzoCalcolato, valutaItem)})
            </span>
          )}
        </ItemPrice>
      </ItemInfo>

      <ItemActions>
        <QuantityGroup>
          <QuantityLabel>Qta:</QuantityLabel>
          <QuantityInput
            type='number'
            min='0'
            step='1'
            value={qta}
            onChange={handleQtaChange}
            onKeyPress={handleKeyPress}
            disabled={isAdded}
            placeholder='Qta'
          />
          {qtaNum > 1 && (
            <ItemDescription>
              = {formatCurrency(subtotale, valutaAzienda)}
              {isDifferentCurrency && (
                <span style={{ fontSize: '0.9em', color: '#6b7280', marginLeft: '4px' }}>
                  ({formatCurrency(prezzoCalcolato * qtaNum, valutaItem)})
                </span>
              )}
            </ItemDescription>
          )}
        </QuantityGroup>

        <ButtonGroup>
          {tipo === 'articoli' && onInfo && (
            <InfoButton
              onClick={() => onInfo(item)}
              title='Visualizza dettagli'
              type='button'
            >
              <FiIcons.FiInfo size={18} />
            </InfoButton>
          )}

          <AddButton
            isAdded={isAdded}
            onClick={handleAdd}
            disabled={isAdded || qtaNum <= 0}
            type='button'
          >
            {isAdded
              ? (
                <>
                  <FiIcons.FiCheckCircle size={16} />
                  Aggiunto
                </>
                )
              : (
                <>
                  <FiIcons.FiPlus size={16} />
                  Aggiungi
                </>
                )}
          </AddButton>
        </ButtonGroup>
      </ItemActions>
    </ItemRow>
  )
}
